import {
    LOGIN_SUCCESS,
    LOGIN_CLEAN,
    LOGIN_EXPIRADO,
    LOGIN_NOVA_PERMISSOES
} from '../actions/actionTypes';
import initialState from './initialState';

export default function loginReducer(state = initialState.login, action) {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return action.login;
        case LOGIN_CLEAN:
            return initialState.login;
        case LOGIN_EXPIRADO:
            return { ...state, mensagem: 'JWTFRONT' };
        case LOGIN_NOVA_PERMISSOES:
            return { ...state, permissoes: action.permissoes };
        default:
            return state;
    }
}
